import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Gate from './../'
import { loadWorkspaces, LOAD } from 'actions/workspace'

export default (props) => {
  const dispatch = useDispatch()

  const open = useSelector((state) => !state.loader[LOAD.WORKSPACES])
  const initialized = useSelector((state) => typeof state.loader[LOAD.WORKSPACES] !== 'undefined')
  const loading = useSelector((state) => state.loader[LOAD.WORKSPACES])

  const onInit = useCallback(() => dispatch(loadWorkspaces()), [dispatch])

  return <Gate
    open={open}
    initialized={initialized}
    loading={loading}
    onInit={onInit}
    {...props} />
}
